import ire from "./assets/flags/ireland.png";
import uk from "./assets/flags/uk.png";
import pol from "./assets/flags/poland.png";
import ger from "./assets/flags/germany.png";
import nor from "./assets/flags/norway.png";
import swe from "./assets/flags/sweden.png";
import den from "./assets/flags/denmark.png";
import spn from "./assets/flags/spain.png";
import us from "./assets/flags/us.png";

export const SUPPORT_CENTER = "https://www.elavon.com/customer-center.html";

export const CONTACT_US = "https://www.elavon.com/contact-us.html";

export const ROUTE = {
  HOME: "/home",
  HELP_CENTER: "/help-center",
  PRE_LOGIN: "/",
  DASHBOARD: "/dashboard",
  REDIRECT: "/redirect",
};

export const LANGUAGE_TYPES = [
  {
    key: "eng",
    value: "English",
  },
];

// Centralized labels for the context-aware login button. Keyed by the same
// "sso" / "external" values used for sessionStorage.loginType so the button
// label and the login-type flag always stay in sync.
export const LOGIN_LABELS = {
  sso: "Login with SSO",
  external: "Log In",
};

export const CONTACT_US_COUNTRIES = [
  {
    language: "en-IE",
    label: "Ireland",
    url_label_text: "elavon.ie",
    url: "https://www.elavon.ie/contact-us.html",
    flag: ire,
  },
  {
    language: "en-GB",
    label: "UK",
    url_label_text: "elavon.co.uk",
    url: "https://www.elavon.co.uk/contact-us.html",
    flag: uk,
  },
  {
    language: "pl-PL",
    label: "Poland",
    url_label_text: "elavon.pl",
    url: "https://www.elavon.pl/kontakt.html",
    flag: pol,
  },
  {
    language: "de-DE",
    label: "Germany",
    url_label_text: "elavon.de",
    url: "https://www.elavon.de/kontakt.html",
    flag: ger,
  },
  {
    language: "nb-NO",
    label: "Norway",
    url_label_text: "elavon.no",
    url: "https://www.elavon.no/kontakt-oss.html",
    flag: nor,
  },
  {
    language: "sv-SE",
    label: "Sweden",
    url_label_text: "elavon.se",
    url: "https://www.elavon.se/kontakta-oss.html",
    flag: swe,
  },
  {
    language: "da-DK",
    label: "Denmark",
    url_label_text: "elavon.dk",
    url: "https://www.elavon.dk/kontakt-os.html",
    flag: den,
  },
  {
    language: "es-ES",
    label: "Spain",
    url_label_text: "elavon.es",
    url: "https://www.elavon.es/contacto.html",
    flag: spn,
  },
  {
    language: "en-US",
    label: "US",
    url_label_text: "elavon.com",
    url: "https://www.elavon.com/customer-center.html",
    flag: us,
  },
];

export const COMBINED_DATA = {
  userProfile: {
    message: "Success",
    data: {
      sessionId: "95d2fd70-d255-4bdf-8238-f90460877f88",
      username: "suppdataqa.globaluser@mocksmtp.azr.com",
      firstName: "suppdataqa",
      lastName: "globaluser",
      email: "suppdataqa.globaluser@mocksmtp.azr.com",
      businessPhone: null,
    },
  },
  userGroupCodes: [
    "Highgate",
    //    "American Airlines",
    //    "Philippine Airlines",
    //    "Highgate",
    //    "Delta",
    //    "Aeromexico",
    //    "Air Canada",
    //    "Loews Hotels",
    //    "Flair Airlines",
    //    "LOT",
    //    "Air France",
    //    "Frontier",
    //    "KLM",
    //    "BP (British Petroleum)",
    //    "TUI Airways",
    //    "Ryanair",
    //    "Spirit",
    //    "Consumer Cellular",
    //    "Emirates",
    //    "Hawaiian",
    //    "SAS",
    //    "LATAM Airlines",
    //    "TAM Airlines",
    //    "US Bank Hotel",
    //    "Advent Health",
    //    "Pepco",
    //    "Red Roof Inn",
    //    "Marriott Acquiring",
    //    "Marriott Internation Europe – Managed",
  ],
  emergencyMode: {
    active: false,
    message:
      "Analytics services are temporarily unavailable due to emergency maintenance. Please try again later.",
  },
  allReports: [
    {
      id: "2305b321-c5db-4bb3-9cdf-1b66e90d9321",
      reportType: "PowerBIReport",
      name: "Authorization Dashboard - Release - V3.0",
      webUrl: null,
      embedUrl: null,
      customerGroupCode: "Delta",
      isFromPbix: true,
      isOwnedByMe: true,
      datasetId: "b4137139-f706-45ee-b97f-66ae778bdedd",
      datasetWorkspaceId: "bc1a8b25-0bb2-4393-b683-918b87081802",
      users: [],
      subscriptions: [],
      killSwitchEnabled: false,
      emergencyMode: null,
      message: null,
      fromPbix: true,
      ownedByMe: true,
    },
    {
      id: "d6f31d7d-1c34-4c8d-98a4-c92db3976203",
      reportType: "PowerBIReport",
      name: "Dispute Dashboard - Release - V3.0",
      webUrl: null,
      embedUrl: null,
      customerGroupCode: "Delta",
      isFromPbix: true,
      isOwnedByMe: true,
      datasetId: "a415614f-2cba-402b-a758-77a08b62d9b5",
      datasetWorkspaceId: "bc1a8b25-0bb2-4393-b683-918b87081802",
      users: [],
      subscriptions: [],
      killSwitchEnabled: false,
      emergencyMode: null,
      message: null,
      fromPbix: true,
      ownedByMe: true,
    },
  ],
};

/**
 * Users allowed to see the "Elavon Hotel" demo experience (5 preview cards).
 * Matched by the email/username local-part (the "firstname.lastname" before the
 * "@"), so the domain is irrelevant - the same person logging in with
 * @elavon.com, @usbank.com, etc. is still matched.
 * NOTE: the appended preview cards are non-clickable placeholders only.
 */
export const PREVIEW_USER_NAMES = [
  "suppdataqa.globaluser",
  "wally.mlynarski",
  "pari.sawant",
  "jake.mcguire",
  "punit.kansal",
  "pankaj.kamble",
  "yuting.shen",
  "prateek.rathore",
  "sudesh.patel",
];

/**
 * Customer group code the demo (preview) users are pinned to. For these users
 * we ignore the group codes returned by combinedData and force this single
 * group so they get the single-group (non super-user) experience.
 */
export const PREVIEW_GROUP_CODE = "Elavon Hotel";

/**
 * Preview ("coming soon") data services. These are NOT entitlements returned by
 * the API - they are injected client side for users in PREVIEW_USER_EMAILS.
 */
export const PREVIEW_REPORTS = [
  //  {
  //    id: "preview-icnd",
  //    reportType: "PowerBIReport",
  //    name: "Interchange & Downgrade Insights",
  //    webUrl: null,
  //    embedUrl: null,
  //    customerGroupCode: null,
  //    datasetId: null,
  //    datasetWorkspaceId: null,
  //    users: [],
  //    subscriptions: [],
  //    killSwitchEnabled: false,
  //    emergencyMode: null,
  //    message: null,
  //    isPreview: true,
  //  },
  {
    id: "preview-reconcilation",
    reportType: "PowerBIReport",
    name: "Reconcilation Data Service",
    webUrl: null,
    embedUrl: null,
    customerGroupCode: null,
    datasetId: null,
    datasetWorkspaceId: null,
    users: [],
    subscriptions: [],
    killSwitchEnabled: false,
    emergencyMode: null,
    message: null,
    isPreview: true,
  },
  {
    id: "preview-executive-insights",
    reportType: "PowerBIReport",
    name: "Executive Insights Data Service",
    webUrl: null,
    embedUrl: null,
    customerGroupCode: null,
    datasetId: null,
    datasetWorkspaceId: null,
    users: [],
    subscriptions: [],
    killSwitchEnabled: false,
    emergencyMode: null,
    message: null,
    isPreview: true,
  },
];
